import { Component, Input } from '@angular/core';
import { CommonModule, NgIf, NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule, NgIf, NgClass, MatIconModule],
  templateUrl: './loading.component.html',
  styles: [
    `.loading-bg { background: linear-gradient(91deg, #12C3F4 2.16%, #11A8FD 43%); }
    .dot { 
        width: 6px; height: 6px; border-radius: 100%;
        background: rgba(255,255,255,0.9);
        display: inline-block; animation:
        pulse 1.2s infinite ease-in-out;

        &.sm { width: 4px; height: 4px; }
    }
    .delay-1 { animation-delay: .1s; }
    .delay-2 { animation-delay: .2s; }
    .delay-3 { animation-delay: .3s; }
    @keyframes pulse { 0%,100% { transform: translateY(0); opacity: .9; } 50% { transform: translateY(-3px); opacity: .6; } }
    `
  ],
  host: {
    class: 'absolute inset-0 z-10 flex items-center justify-center w-full'
  }
})
export class LoadingComponent {
  @Input() label: string | null = null;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
}


